import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, inject, input } from '@angular/core';
import { FooterComponent, HeaderComponent, NavBarComponent } from '@shared/components';
import { BreakpointFacade } from '@core/facades';

@Component({
  standalone: true,
  selector: 'cheelee-responsive-layout',
  templateUrl: './responsive-layout.component.html',
  styleUrl: './responsive-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NavBarComponent,
    HeaderComponent,
    FooterComponent,
  ],
})
export class ResponsiveLayoutComponent {
  readonly displayNavBar = input(false, { transform: booleanAttribute });

  readonly onePage = input(false, { transform: booleanAttribute });

  readonly isHeaderFixed = input(true, { transform: booleanAttribute });

  readonly isFooterCompact = input(false, { transform: booleanAttribute });

  readonly isDesktop = inject(BreakpointFacade).isDesktop;

  @HostBinding('class')
  get classes(): Record<string, boolean> {
    return {
      'chl-layout--onepaged': this.onePage(),
    };
  }
}
